// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BWdG8","name":"styles_name__3t85k","phone":"styles_phone__1hpLm"};